import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';

export class CopyBlockTemplateModalBloc extends BaseBloc {
  private readonly proposalTemplateBloc = resolve(Blocs.proposalTemplate);

  readonly loading = new LoadingState();

  copyBlockTemplate = this.proposalTemplateBloc.copyBlockTemplate;
}
